module.exports = __webpack_public_path__ + "assets/8c8a830ae24ce8153fc0eb48e357528e.mp3";